import { render, staticRenderFns } from "./RoomDetails.vue?vue&type=template&id=0b6e26f5&"
import script from "./RoomDetails.vue?vue&type=script&lang=js&"
export * from "./RoomDetails.vue?vue&type=script&lang=js&"
import style0 from "./RoomDetails.vue?vue&type=style&index=0&id=0b6e26f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports